import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import { DateFilterService } from '../../../Services/dateFilter.service';
import { Title } from '@angular/platform-browser';
import { NotificationService } from '../../../Services/notification.service';
import { FilterPipe } from 'ngx-filter-pipe';
import { AppConfigService } from '../../../Services/app-config.service';
import { DatePipe, ViewportScroller } from '@angular/common';
import { DecimalNewPipe } from '../../common/DecimalNewPipe';
import { ResponseModel } from '../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-statistical-list',
  templateUrl: './statistical-list.component.html',
  styleUrls: ['./statistical-list.component.css'],
  standalone: false
})
export class StatisticalListComponent extends ListPageBase implements OnInit, OnDestroy {

  vm: any = {};
  statisticalCount = 0;
  isLoaded = false;

  constructor(
    private route: ActivatedRoute,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private cd: ChangeDetectorRef,
    private datePipe: DatePipe,
    private decimalPipe: DecimalNewPipe,
    private vps: ViewportScroller,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
    this.vm.list = [];
    this.vm.statisticalSearch = [];
    this.vm.batches = [];
    this.vm.batchFilter = {};
  }




  show = false;
  selectItems;

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];

    this.titleService.setTitle($localize`:Statistical Entries @@statisticalEntries:Statistical Entries`);

    this.vm.owingSelected = this.vm.totalSelected = 0;

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences', ''));
    this.vm.batchesHidden = !this.vm.Preferences.ShowBatches;

    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
    if (
      !this.vm.permissions.EditJournalEntries &&
      !this.vm.permissions.ViewJournalEntries &&
      !this.vm.permissions.Admin
    ) {
      document.location.href = '/';
    }

    this.vm.statisticalFilter = this.localStorage.StorageGet('statisticalFilter', {
      text: '',
      sort: 'audit_sequence',
      ascending: true,
    });

    this.vm.statisticalSearch = this.localStorage.StorageGet('statisticalSearch', '');
    this.vm.statisticalToDate = this.localStorage.StorageGet('statisticalToDate', '');
    this.vm.statisticalFromDate = this.localStorage.StorageGet('statisticalFromDate', '');
    this.vm.statisticalNumberOfResults = '25';
    this.vm.statisticalSearchLocked = this.localStorage.StorageGet('statisticalSearchLocked', '');

    // Restore pager from enhanced per-tab cache (sessionStorage + memory)
    this.init();
  }


  ngOnDestroy(): void {
    // no legacy datatable resources to clean
  }




  init() {
    this.vm.searching = true;
    this.vm.batchId = undefined;
    this.vm.tempDescription = '';

    let paramString = '';
    paramString += 'batchType=16';
    paramString += '&search=' + (this.vm.statisticalSearch ? this.vm.statisticalSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.statisticalFromDate ? this.dateFilter.GetDateFormat(this.vm.statisticalFromDate) : '');
    paramString +=
      '&toDate=' + (this.vm.statisticalToDate ? this.dateFilter.GetDateFormat(this.vm.statisticalToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + (this.vm.statisticalNumberOfResults ? this.vm.statisticalNumberOfResults : '');
    paramString += '&includePosted=' + (this.vm.includePosted ? this.vm.includePosted : '');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      paramString += 'search=' + (this.vm.statisticalSearch ? this.vm.statisticalSearch : '');
      paramString +=
        '&fromDate=' + (this.vm.statisticalFromDate ? this.dateFilter.GetDateFormat(this.vm.statisticalFromDate) : '');
      paramString +=
        '&toDate=' + (this.vm.statisticalToDate ? this.dateFilter.GetDateFormat(this.vm.statisticalToDate) : '');
      paramString +=
        '&numberOfResults=' + (this.vm.statisticalNumberOfResults ? this.vm.statisticalNumberOfResults : '');
      paramString += '&recurring=false';
      paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;

      this.tableDataService.getApiListData('StatisticalList', '?' + paramString).subscribe((result2: ResponseModel) => {
        this.vm.list = result2.Data;
        // console.log('sysusr data:' + JSON.stringify(this.vm.list));
        this.totalRecords = result2.totalRecords;
        this.paginate(false);

        this.convertToNumbers();
        this.vm.searching = false;
        this.statisticalCount = this.vm.list.length;
        this.isLoaded = true;
      });
    });

    this.localStorage.StorageSet('statisticalSearch', this.vm.statisticalSearch);
    this.localStorage.StorageSet('statisticalToDate', this.vm.statisticalToDate);
    this.localStorage.StorageSet('statisticalFromDate', this.vm.statisticalFromDate);
    this.localStorage.StorageSet('statisticalSearchLocked', this.vm.statisticalSearchLocked);
    this.localStorage.StorageSet('statisticalNumberOfResults', this.vm.statisticalNumberOfResults);
  }

  filter(filter) {
    this.vm.statisticalFilter = Object.assign(this.vm.statisticalFilter, filter);
    this.localStorage.StorageSet('statisticalFilter', JSON.stringify(this.vm.statisticalFilter));
  }

  convertToNumbers() {
    for (const obj of this.vm.list) {
      obj.header_amount = Number(obj.header_amount);
      obj.audit_sequence = Number(obj.audit_sequence);
    }
  }

  updateBatchesSelectedInModal(batchId: string) {
    this.getBatchItems2(batchId);
    // this.paginate(false);
  }

  getBatchItems(batchId) {
    // console.log('batchid:' + batchId);
    this.vm.tempDescription = '';
    this.vm.batchId = batchId;
    this.vm.searching = true;
    this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
    this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;

    let paramString = '';
    paramString += 'batch_id=' + (this.vm.batchId ? this.vm.batchId : '');
    this.tableDataService.getApiListData('StatisticalList', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.convertToNumbers();
      this.vm.searching = false;
      // this.setList(this.vm.list);
    });
  }

  getBatchItems2(batchId) {
    this.vm.tempDescription = '';
    this.vm.batchId = batchId;
    this.vm.searching = true;
    this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
    this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;
    this.tableDataService.getData('StatisticalList', '?batchId=' + this.vm.batchId + '&recurring=false').pipe().subscribe((result: any) => {
      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.list = result.Data;
      this.vm.listInitiated = true;
    });
  }

  getBatches() {
    this.vm.searching = true;

    let paramString = '';
    paramString += 'batchType=16';
    paramString += 'recurring=false';
    paramString += '&search=' + (this.vm.statisticalSearch ? this.vm.statisticalSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.statisticalFromDate ? this.dateFilter.GetDateFormat(this.vm.statisticalFromDate) : '');
    paramString +=
      '&toDate=' + (this.vm.statisticalToDate ? this.dateFilter.GetDateFormat(this.vm.statisticalToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + (this.vm.statisticalNumberOfResults ? this.vm.statisticalNumberOfResults : '');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      if (this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true).length === 1) {
        this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
        this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;
      }
      this.vm.searching = false;
    });
  }

  // newBatch() {
  //   const newBatch = { type_id: 1 };
  //
  //   this.tableDataService.post('t_batch', newBatch).subscribe(
  //     (item: any) => {
  //       this.getBatches();
  //       this.vm.batchId = item.id;
  //       this.vm.tempDescription = 'Batch';
  //       this.notification.info($localize`:success @@success:success`);
  //     },
  //     (error: { error: { Message: string }; statusText: string }) => {
  //       let ErrorMsg: string;
  //       if (typeof error.error.Message !== 'undefined') {
  //         ErrorMsg = error.error.Message;
  //       } else {
  //         ErrorMsg = error.statusText;
  //       }
  //       this.vm.buttonsDisabled = false;
  //       this.notification.error(error);
  //     }
  //   );
  // }
  //
  // updateBatch() {
  //   this.vm.buttonsDisabled = true;
  //   const changes = { description: this.vm.tempDescription };
  //   this.tableDataService
  //     .patch('t_batch', this.vm.batchId, changes)
  //     .then((item: any) => {
  //       if (item) {
  //         this.notification.info(this.vm.tempDescription);
  //       }
  //       this.getBatches();
  //     })
  //     .catch((msg: string) => {
  //       this.vm.buttonsDisabled = false;
  //       this.notification.error(msg);
  //     });
  // }
  //
  // postBatch(batchId) {
  //   this.vm.buttonsDisabled = true;
  //   const changes = { locked: 'true' };
  //
  //   this.tableDataService
  //     .patch('t_batch', batchId, changes)
  //     .then((item: any) => {
  //       if (item) {
  //         this.notification.info(item.description);
  //       }
  //       this.getBatches();
  //     })
  //     .catch((msg: string) => {
  //       this.vm.buttonsDisabled = false;
  //       this.notification.error(msg);
  //     });
  // }

  hideBatches() {
    // this.vm.buttonsDisabled = true;
    this.vm.batchesHidden = !this.vm.batchesHidden;
    this.vm.Preferences.ShowBatches = !this.vm.batchesHidden;
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  // Server side paging ---------------------------------------------------------------------------------
  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    this.vm.searching = true;
    this.vm.batchId = undefined;
    this.vm.tempDescription = '';

    let paramString = '';
    paramString += 'batchType=16';
    paramString += '&search=' + (this.vm.statisticalSearch ? this.vm.statisticalSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.statisticalFromDate ? this.dateFilter.GetDateFormat(this.vm.statisticalFromDate) : '');
    paramString +=
      '&toDate=' + (this.vm.statisticalToDate ? this.dateFilter.GetDateFormat(this.vm.statisticalToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + (this.vm.statisticalNumberOfResults ? this.vm.statisticalNumberOfResults : '');
    paramString += '&includePosted=' + (this.vm.includePosted ? this.vm.includePosted : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('StatisticalList', '?' + paramString).subscribe((result2: ResponseModel) => {
      this.vm.list = result2.Data;
      this.totalRecords = result2.totalRecords;
      this.paginate(false);

      this.convertToNumbers();
      this.vm.searching = false;
      //this.setList(this.vm.list);
      this.isLoaded = true;
    });
  }

  scrollTo(anchor: string): void {
    if (!this.vm.batchesHidden) {
      this.vps.scrollToAnchor(anchor);
    }
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }


  serverSearch(value) {
    this.vm.statisticalSearch = value.searchTerm;
    this.vm.statisticalFromDate = value.fromDate;
    this.vm.statisticalToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.statisticalSearch = value.searchTerm;
    this.vm.statisticalFromDate = value.fromDate;
    this.vm.statisticalToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  onNavigate(aID: string, print = false) {
    this.router.navigate(['/transactions/statistical/form'], { queryParams: { statisticalId: aID } });
  }
}
